import { render, staticRenderFns } from "./ProfileAvatarDialog.vue?vue&type=template&id=2d359a12&"
import script from "./ProfileAvatarDialog.vue?vue&type=script&lang=ts&"
export * from "./ProfileAvatarDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports